import axios from "axios";

/**
 * True only for a genuine auth rejection (token invalid/revoked): an axios
 * 401 or 403. Everything else — network error, timeout, 5xx — is treated as a
 * transient failure that must NOT clear the user's session.
 */
export function isAuthRejection(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;

  const status = error.response?.status;
  return status === 401 || status === 403;
}
